export default {
  MULTI: {
    SELECT: 'SELECT_MULTI_EDGE',
    DELETE: {
      REQUEST: 'REQUEST_DELETE_MULTI_EDGE',
      RECEIVE: 'RECEIVE_DELETE_MULTI_EDGE',
      FAIL: 'FAIL_DELETE_MULTI_EDGE',
      NOTIFY: 'NOTIFY_DELETE_MULTI_EDGE'
    }
  },
  ONE: {
    START_EDITING: 'START_EDITING_ONE_EDGE',
    STOP_EDITING: 'STOP_EDITING_ONE_EDGE',
    SELECT: 'SELECT_ONE_EDGE',
    DESELECT: 'DESELECT_ONE_EDGE',
    CREATE: {
      REQUEST: 'REQUEST_CREATE_ONE_EDGE',
      RECEIVE: 'RECEIVE_CREATE_ONE_EDGE',
      FAIL: 'FAIL_CREATE_ONE_EDGE',
      NOTIFY: 'NOTIFY_CREATE_ONE_EDGE'
    },
    EDIT: {
      REQUEST: 'REQUEST_EDIT_ONE_EDGE',
      RECEIVE: 'RECEIVE_EDIT_ONE_EDGE',
      FAIL: 'FAIL_EDIT_ONE_EDGE',
      NOTIFY: 'NOTIFY_EDIT_ONE_EDGE'
    },
    DELETE: {
      REQUEST: 'REQUEST_DELETE_ONE_EDGE',
      RECEIVE: 'RECEIVE_DELETE_ONE_EDGE',
      FAIL: 'FAIL_DELETE_ONE_EDGE',
      NOTIFY: 'NOTIFY_DELETE_ONE_EDGE'
    }
  }
}
